import {
  NEW_PASSWORD_FAIL,
  NEW_PASSWORD_REQUEST,
  NEW_PASSWORD_SUCCESS,
} from "../../constants/actions";

const initialState = {
  loading: false,
  newPass: false,
  error: false
};

const newPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case NEW_PASSWORD_SUCCESS:
      return {
        loading: false,
        newPass: true,
        error: false,
      };
    case NEW_PASSWORD_FAIL:
      return {
        loading: false,
        newPass: false,
        error: true,
      };
    default:
      return state;
  }
};

export default newPasswordReducer;
